<template lang="pug">
  .component-smart-edit-field(v-if="shouldShow")
    .title
      span.label  {{ title }}
    .object(v-if="typeof value == 'object' && value !== null && type !== 'map' && type !== 'select'")
      .field(v-for="(item, index) in mutableField")
        smart-edit-field(v-model="mutableField[index]", :name="name+'.'+index", :options="options")
    .line(v-else="")
      date-picker(v-if="type === 'date'", v-model="mutableField", :disabled="shouldDisable", :initialDate="mutableField", :format="'yyyy-mm-dd'")
      date-picker(v-else-if="type === 'datetime'", v-model="mutableField", :disabled="shouldDisable", :initialDate="mutableField", :pickTime="true", :format="'yyyy-mm-dd hh:ii'")
      date-picker(v-else-if="type === 'datetimes'", v-model="mutableField", :disabled="shouldDisable", :initialDate="mutableField", :pickTime="true", :format="'yyyy-mm-dd hh:ii:ss'")
      select(v-else-if="type instanceof Array", v-model="mutableField", :disabled="shouldDisable")
        option(v-for="option in type", :value="option") {{ option }}
      input(v-else-if="type ==='password'", type="password", v-model="mutableField", :disabled="shouldDisable")
      input(v-else-if="type ==='checkbox'", type="checkbox", v-model="mutableField", :disabled="shouldDisable")
      div(v-else-if="type === 'select'")
        select(v-model="mutableField")
          option(v-for="(value,id) in options.select", :value="id") {{id}} {{value}}
      div(v-else-if="type === 'file'")
        input(type="text", v-model="mutableField", disabled)
        //pre {{options.file.selectedPrefix}}
        kepler-file-upload(@sel="handleFileSelector", :selectedVisibility="options.file.selectedVisibility", :selectedPrefix="options.file.selectedPrefix")
      #map(v-else-if="type === 'map'")
        GoogleMapContainer
          google-map(style="height:10px", ref="map", :api-key="mapsAPI", :searchBar="true", :mapTypeId="'roadmap'", :mapTypeControl="true", :center="mutableField", @mapClicked="mapClicked" :zoom="20", :listenForClick="true")
            google-map-marker(:position="mutableField", label="", title="", ref="marker")
      Editor(v-else-if="type === 'editor'", v-model="mutableField", :value="mutableField")
      input(v-else="", type="text", v-model="mutableField", :disabled="shouldDisable")

</template>
<script type="text/babel">
  import DatePicker from "./DatePicker";
  import KeplerFileUpload from "./KeplerFileUpload";
  import GoogleMap from '../../lib/map/GoogleMap'
  import GoogleMapMarker from '../../lib/map/GoogleMapMarker'
  import Editor from "./ui/Editor";
  import GoogleMapContainer from '../backoffice/GoogleMapContainer'

  export default {
    components: {GoogleMapContainer, Editor, KeplerFileUpload, DatePicker, GoogleMap, GoogleMapMarker},
    name: "SmartEditField",
    data: function () {
      return {
        mutableField: this.value,
      }
    },
    watch: {
      mutableField: function (newValue) {
        this.$emit('input', newValue)
      },
      value: function (newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.mutableItem)) {
          this.mutableField = newValue
        }
      }
    },
    methods: {
      handleFileSelector(path) {
        this.mutableField = path
        this.showFileSelector = false
      },
      mapClicked(e) {
        this.mutableField = {lat: e.lat(), lng: e.lng()}
        this.$refs.marker.setPosition(this.mutableField)
      }
    },
    computed: {
      mapsAPI: function () {
        return window.env.GOOGLE_MAPS_KEY
      },
      type: function () {
        if (!this.options.types) {
          return 'text'
        }
        if (this.options.types[this.name]) {
          return this.options.types[this.name]
        } else {
          return 'text'
        }
      },
      title: function () {
        if (this.options.translations[this.name]) {
          return this.options.translations[this.name]
        } else {
          return this.name
        }
      },
      shouldShow: function () {
        var inList = this.options.list.indexOf(this.name) != -1;
        switch (this.options.listMode) {
          case 'whitelist':
            return inList;
            break;
          case 'blacklist':
            return !inList;
            break;
          default:
            console.warn("No valid list mode for SmartEdit, using whitelist");
            return inList
        }
      },
      shouldDisable: function () {
        var inList = this.options.disabled.indexOf(this.name) != -1;
        return inList;
      }
    },
    props: [
      'value',
      'name',
      'options'
    ],
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-smart-edit-field
    .object
      padding-left: 25px
    #map
      height: 350px
</style>



// WEBPACK FOOTER //
// SmartEditField.vue?0fb1f316